export default __webpack_public_path__ + "static/media/Pearl Ring of Assault.28ff40bc.jpg";